import { WorkspaceAction } from '@sales-app/context/workspace/workspace.actions'
import { useWorkspaceContext } from '@sales-app/context/workspace/workspace.hooks'
import { HomeFilters } from '@sales-app/context/workspace/workspace.type'
import { DateRangeSelection } from '@shared/components'
import React, { FC } from 'react'

type Props = {
  currentFilters: HomeFilters
}
export const MoveInSelection: FC<Props> = ({ currentFilters }) => {
  const [, workspaceDispatch] = useWorkspaceContext()
  const { moveInEndDate, moveInStartDate } = currentFilters

  return (
    <DateRangeSelection
      endDate={moveInEndDate}
      setEndDate={(d?: Date) => workspaceDispatch(WorkspaceAction.updateFilters({ moveInEndDate: d }))}
      setStartDate={(d?: Date) => workspaceDispatch(WorkspaceAction.updateFilters({ moveInStartDate: d }))}
      startDate={moveInStartDate}
    />
  )
}
